import { render } from "./ErpCustomerRelation.vue?vue&type=template&id=32df3980&scoped=true"
import script from "./ErpCustomerRelation.vue?vue&type=script&lang=js"
export * from "./ErpCustomerRelation.vue?vue&type=script&lang=js"

import "./ErpCustomerRelation.vue?vue&type=style&index=0&id=32df3980&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32df3980"],['__file',"src/views/qywx/ai/erpCustomerRelation/ErpCustomerRelation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32df3980"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32df3980', __exports__)) {
    api.reload('32df3980', __exports__)
  }
  
  module.hot.accept("./ErpCustomerRelation.vue?vue&type=template&id=32df3980&scoped=true", () => {
    api.rerender('32df3980', render)
  })

}


export default __exports__